// extracted by mini-css-extract-plugin
export default {"button":"FullScreenButton_button__8jQgx"};